/* eslint-disable max-len */
import React from 'react';
import { useMediaPredicate } from 'react-media-hook';
import classNames from 'classnames';

import {
	CheckboxField, Form
} from 'components/Form';
import decodeHtml from 'utilities/decodeHtml';
import { media } from 'utilities/browser';

import ProductItemImage from './ProductItemImage';
import ProductItemPrice from './ProductItemPrice';

import './ProductCheckableListItem.scss';

type ProductCheckableListItemProps = {
	product: LP.product.ProductItem
	name: string,
	formId: number | string,
	skipMainProductSkuView?: boolean,
	imageSize?: number,
	onChange?: (e: React.ChangeEvent<HTMLInputElement>, product?: LP.product.ProductItem) => void,
	onClick?: (e: React.MouseEvent<HTMLAnchorElement>) => void,
}

const ConditionalLinkWrapper = ({
	includeLink, url, onClick, children
}: React.PropsWithChildren<{ includeLink: boolean, url: string, onClick: (e: React.MouseEvent<HTMLAnchorElement>) => void }>) => {

	if (includeLink) {

		return (
			<a
				href={url}
				onClick={(e) => {

					onClick(e);

				}}
			>
				{children}
			</a>
		);

	}
	return (
		<>
			{children}
		</>
	);

};

const ProductCheckableListItem = ({
	product, name, formId, skipMainProductSkuView = false, imageSize = 274, onChange = () => {}, onClick = () => {}
}: ProductCheckableListItemProps) => {

	const decodedProductName = decodeHtml(product.ProductName);
	const checkboxId = `${formId}-${name}-${product.ShortSku}`;

	const isMediaDesktop = useMediaPredicate(media.DESKTOP);
	const className = classNames('ProductCheckableListItem', {
		'ProductCheckableListItem--openbox': product.IsOpenBox
	});

	return (
		<div className={className}>
			{isMediaDesktop ? (
				<>
					<div className="ProductCheckableListItem__imageWrapper">
						<ConditionalLinkWrapper
							includeLink={!product.IsMainProduct}
							url={product.ProductDetailUrl}
							onClick={(e) => {

								if (!product.IsMainProduct) {

									onClick(e);

								}

							}}
						>
							<ProductItemImage product={product} width={imageSize} height={imageSize} skipMainProductSkuView={skipMainProductSkuView} />
						</ConditionalLinkWrapper>
					</div>
					<div className="ProductCheckableListItem__checkboxWrapper">
						<Form
							onSubmit={null}
							validationSchema={null}
							className={null}
							method={null}
							defaultValues={{
								[name]: product.ShortSku
							}}
						>
							<CheckboxField
								name={name}
								id={checkboxId}
								value={product.ShortSku}
								onChange={(e: React.ChangeEvent<HTMLInputElement>) => {

									onChange(e, product);

								}}
							>
								<span className="sr-only">
									{decodedProductName}
								</span>
							</CheckboxField>
						</Form>
					</div>

					<ConditionalLinkWrapper
						includeLink={!product.IsMainProduct}
						url={product.ProductDetailUrl}
						onClick={(e) => {

							if (!product.IsMainProduct) {

								onClick(e);

							}

						}}
					>
						<div className="ProductCheckableListItem__namePriceWrapper">
							<div className="ProductCheckableListItem__name">
								{product.IsMainProduct && (
									<strong>
This Item:
										{' '}
									</strong>
								)}
								<span title={decodedProductName}>
									{decodedProductName}
								</span>
							</div>
							<ProductItemPrice
								product={product}
								priceText={product.PriceText}
							/>
						</div>
					</ConditionalLinkWrapper>
				</>
			)
				: (
					<>
						<div className="ProductCheckableListItem__checkboxWrapper">
							<Form
								onSubmit={null}
								validationSchema={null}
								className={null}
								method={null}
								defaultValues={{
									[name]: product.ShortSku
								}}
							>
								<CheckboxField
									name={name}
									id={checkboxId}
									value={product.ShortSku}
									onChange={(e: React.ChangeEvent<HTMLInputElement>) => {

										onChange(e, product);

									}}
								>
									<span className="sr-only">
										{decodedProductName}
									</span>
								</CheckboxField>
							</Form>
						</div>

						<div className="ProductCheckableListItem__imageWrapper">
							<ConditionalLinkWrapper
								includeLink={!product.IsMainProduct}
								url={product.ProductDetailUrl}
								onClick={(e) => {

									if (!product.IsMainProduct) {

										onClick(e);

									}

								}}
							>
								<ProductItemImage product={product} width={imageSize} height={imageSize} skipMainProductSkuView={skipMainProductSkuView} />
							</ConditionalLinkWrapper>
						</div>

						<ConditionalLinkWrapper
							includeLink={!product.IsMainProduct}
							url={product.ProductDetailUrl}
							onClick={(e) => {

								if (!product.IsMainProduct) {

									onClick(e);

								}

							}}
						>
							<div className="ProductCheckableListItem__namePriceWrapper">
								<div className="ProductCheckableListItem__name">
									{product.IsMainProduct && (
										<strong>
This Item:
											{' '}
										</strong>
									)}
									<span title={decodedProductName}>
										{decodedProductName}
									</span>
								</div>
								<ProductItemPrice
									product={product}
									priceText={product.PriceText}
								/>
							</div>
						</ConditionalLinkWrapper>
					</>
				)			}
		</div>
	);

};

export default ProductCheckableListItem;
